import type React from 'react';
import type { OptionsMenuItem } from '../OptionsMenu';
import { RoundedButton } from '../../../../form/Button';
import { OptionsMenu } from '../OptionsMenu';
import { MEASURING_POINT_CELL_CLASSES } from './cellClasses';

interface ProjectMeasuringPointActionsCellProps {
    calibrationSkeletonCount: number;
    id: string;
    isArchived: boolean;
    menuItems: OptionsMenuItem[];
    onOpenChange: (open: boolean) => void;
}

export function ProjectMeasuringPointActionsCell({
    calibrationSkeletonCount,
    id,
    isArchived,
    menuItems,
    onOpenChange,
}: ProjectMeasuringPointActionsCellProps): React.ReactElement {
    return (
        <td className={MEASURING_POINT_CELL_CLASSES}>
            <div className="flex items-center justify-end gap-2">
                {!isArchived && (
                    <RoundedButton href={`/sbr/sbrView/#${id}`} className="whitespace-nowrap">
                        {gettext('WALKTHROUGH_GRAPH_VIEW-DATA_TITLE')}
                    </RoundedButton>
                )}
                <OptionsMenu
                    items={menuItems}
                    ariaLabel={gettext('OPTIONS')}
                    onOpenChange={onOpenChange}
                    calibrationSkeletonCount={calibrationSkeletonCount}
                />
            </div>
        </td>
    );
}
